import styled from 'styled-components';

export const Container = styled.div`
  margin: 64px auto;
  padding: 0 24px;
  max-width: 800px;
`;

export const Title1 = styled.p`
  font-size: 40px;
  font-weight: bold;
  margin-bottom: 16px;
`;

export const Text = styled.p`
  ${props => (props.bold ? `font-weight: bold;` : '')}

  margin-bottom: 20px;
`;

export const Span = styled.span`
  ${props => (props.bold ? `font-weight: bold;` : '')}
`;

export const Updated = styled.p`
  color: #859099;
  margin-bottom: 44px;
  font-size: 14px;
`;
